import React, { Component, Fragment } from 'react';
import { PropTypes } from 'prop-types';

class DropDownSelector extends Component {
  state = {
    // The active selection's index
    activeSuggestion: 0,
    // The suggestions that match the user's input
    filteredSuggestions: [],
    // Whether or not the suggestion list is shown
    showSuggestions: false,
    // What the user has entered
    userInput: '',
  };

  componentDidMount() {
    const { value } = this.props;
    if (value) {
      this.setState({
        userInput: value,
      });
    }
  }


  componentDidUpdate(prevProps, prevState) {
    const { suggestions } = this.props;
    const filteredSuggestions = suggestions;
    if (prevProps.suggestions !== suggestions) {
      this.setState({ filteredSuggestions, showSuggestions: true, activeSuggestion: 0 });
    }
    const { value } = this.props;
    if (prevProps.value !== value) {
      this.setState({
        userInput: value,
      });
    }
  }

  onChange = (e) => {
    const { suggestions } = this.props;
    const userInput = e.currentTarget.value;

    // Filter our suggestions that don't contain the user's input
    const filteredSuggestions = suggestions.filter(suggestion => suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1);

    this.setState({
      activeSuggestion: 0,
      filteredSuggestions,
      showSuggestions: true,
      userInput,
    });
  };

  onClick = (e) => {
    const { storeOption } = this.props;
    storeOption(e.currentTarget.innerText);
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: e.currentTarget.innerText,
    });
  };

  render() {
    const {
      onChange,
      onClick,
      state: {
        activeSuggestion, filteredSuggestions, showSuggestions, userInput,
      },
    } = this;

    const {
      message, title, value, action, margin,
    } = this.props;

    let suggestionsListComponent;

    if (showSuggestions) {
      if (filteredSuggestions.length) {
        suggestionsListComponent = (
          <ul className="list-none mt-0 pl-0" style={{ overflowY: 'auto', width: 'calc(300px + 1 rem)' }}>
            {filteredSuggestions.map((suggestion, index) => {
              let className;

              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = 'cursor-pointer';
              }

              return (
                <li className={`${className} p-2 uppercase hover:text-black hover:bg-greyFilterItems hover:rounded-full rounded-full `} key={suggestion} onClick={onClick}>
                  {suggestion}
                </li>
              );
            })}
          </ul>
        );
      } else if (userInput.length !== 0 && filteredSuggestions.length !== 0) {
        suggestionsListComponent = (
          <div className="no-suggestions mt-2">
            <em>Venue already selected</em>
          </div>
        );
      } else {
        suggestionsListComponent = (
          <div className="no-suggestions mt-2">
            <em>{message}</em>
          </div>
        );
      }
    }

    return (
      <Fragment>
        {(action === 'create' || action === 'modify') && (
          <div className={`flex flex-col font-americaMonoRegular text-xs uppercase ${margin || 'mb-2'}`}>
            <span>{title}</span>
            <input type="text" onChange={onChange} value={userInput} className="mt-2 rounded-full border-1 p-2 bg-white text-black outline-none" />
            {suggestionsListComponent}
          </div>
        )}
        {(action === 'display' || action === 'delete') && (
          <div className={`flex flex-col font-americaMonoRegular text-xs uppercase ${margin || 'mb-2'}`}>
            <span>{title}</span>
            <input type="text" value={value} className="mt-2 rounded-full border-1 p-2 bg-grey text-black outline-none" disabled />
          </div>
        )}
      </Fragment>
    );
  }
}

DropDownSelector.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  value: PropTypes.string,
  message: PropTypes.string.isRequired,
  storeOption: PropTypes.func.isRequired,
  margin: PropTypes.string,
};

DropDownSelector.defaultProps = {
  value: '',
  margin: '',
};

export default DropDownSelector;
